import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-esr-submit',
    imports: [],
    templateUrl: './esr-submit.component.html',
    styleUrl: './esr-submit.component.scss'
})
export class EsrSubmitComponent implements OnInit {
  ngOnInit() {}
}
